import { Outlet, useParams } from "react-router-dom";
import { isSupportedLocale } from "../localeConfig";
import NoPage from "./NoPage";

const LocaleGate = () => {
  const { locale } = useParams();
  if (!isSupportedLocale(locale)) {
    return <NoPage />;
  }
  return <Outlet />;
};

export default LocaleGate;
